import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { appInsights } from '../../lib/appInsights';

/**
 * Component that tracks page views on every route change.
 * Should be placed inside the <BrowserRouter> but outside <Routes>.
 */
const TelemetryTracker: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        // We add a small delay to ensure the page title is updated if modified by a screen component
        const timer = setTimeout(() => {
            // Priority: document.title (if not just generic) -> formatted pathname -> location.pathname
            let pageName = document.title;
            if (!pageName || pageName === 'Kanea') {
                const pathParts = location.pathname.split('/').filter(p => p);
                pageName = pathParts.length > 0
                    ? pathParts[pathParts.length - 1].charAt(0).toUpperCase() + pathParts[pathParts.length - 1].slice(1)
                    : 'Home';
            }

            appInsights.trackPageView({
                name: pageName,
                uri: window.location.href,
                properties: {
                    path: location.pathname,
                    search: location.search,
                    full_title: document.title
                }
            });
            console.log(`[Telemetry] PageView tracked: ${pageName} (${location.pathname}${location.search})`);
        }, 300);

        return () => clearTimeout(timer);
    }, [location]);

    return null;
};

export default TelemetryTracker;
